import React from 'react'

const SearchModel = () => {
    return (
        <div className="modal fade" id="exampleModal" tabIndex="-1" aria-labelledby="exampleModalLabel" aria-hidden="true">
            <button type="button" className="close-search-btn" data-bs-dismiss="modal" aria-label="Close">
                <i className='bx bx-plus'></i>
            </button>
            <div className="modal-dialog">
                <div className="modal-content">
                    <div className="modal-body">
                        <form className="search-form" onSubmit={(e)=>e.preventDefault()}>
                            <input required className="search-input" name="search" placeholder="Search..." type="text" />
                            <button type="submit" className="search-button">
                                <i className="flaticon-search"></i>
                            </button>
                        </form>
                    </div>
                </div>
            </div>
        </div>
    )
}

export default SearchModel